import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-lp',
    templateUrl: './lp.component.html',
    styleUrls: ['./lp.component.css'],
    standalone: false
})
export class LpComponent implements OnInit {

  constructor(
  ) { }

  ngOnInit() {
    window.scroll(0, 0);
  }
}
